import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchJobListByCompany } from "./JobsByCompanyAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobListByCompanyAsync = createAsyncThunk(
  "company/fetch",
  async ({uuid}, { rejectWithValue }) => {
    try {
      const data = await fetchJobListByCompany(uuid);

      const resp = data?.response?.data;
      // console.log("job list", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



const JobsByCompanySlice = createSlice({
  name: "JobsByCompany",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchJobListByCompanyAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobListByCompanyAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchJobListByCompanyAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      // .addCase(fetchCompanyProfileAsync.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(fetchCompanyProfileAsync.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.data = action.payload;
      //   // console.log("DAta", action.payload)
      //   state.error = null;
      // })
      // .addCase(fetchCompanyProfileAsync.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload || action.error.message;
      // })
  },
});

export const selectCompanyJobs = (state) => state.jobsByCompany.data;


export default JobsByCompanySlice.reducer;
